__turbopack_context__.v({
  "divider": "Divider-module__-s3Xaq__divider",
  "dividerHorizontal": "Divider-module__-s3Xaq__dividerHorizontal" + " " + "Divider-module__-s3Xaq__divider",
  "dividerResponsive": "Divider-module__-s3Xaq__dividerResponsive" + " " + "Divider-module__-s3Xaq__divider",
  "dividerVertical": "Divider-module__-s3Xaq__dividerVertical" + " " + "Divider-module__-s3Xaq__divider",
});
